import _ from "lodash";
import {$core} from "@isudio/core";
import {$store} from "@isudio/globals";
import type {IAsset} from "@isudio/data";
import {AssetReactionOrder} from "@isudio/data";
import type {IAssetReactionSummary} from "@isudio/data";

export const setAppData = async (): Promise<void> => {
  $core.getAppData().then((data: any) => {
    if (_.get(data, 'policies.length', 0) > 0) {
      const userPolicy = _.find(_.get(data, 'policies'), {type: "userPolicy"});
      if (!_.isNothing(userPolicy)) {
        (_.get($store, 'Data.userPolicy$') as any)?.next(userPolicy);
      }

      const privacyPolicy = _.find(_.get(data, 'policies'), {type: "privacyPolicy"});
      if (!_.isNothing(privacyPolicy)) {
        (_.get($store, 'Data.privacyPolicy$') as any)?.next(privacyPolicy);
      }

      const termsOfUse = _.find(_.get(data, 'policies'), {type: "termsOfUse"});
      if (!_.isNothing(termsOfUse)) {
        (_.get($store, 'Data.termsOfUse$') as any)?.next(termsOfUse);
      }
    }

    if (_.get(data, 'team.length', 0) > 0) {
      const team = _.get(data, 'team', null);
      if (!_.isNothing(team)) {
        (_.get($store, 'Data.team$') as any)?.next(team);
      }
    }

    if (_.get(data, 'assets.length', 0) > 0) {
      (_.get($store, 'Data.assets$') as any)?.next(
        data.assets.map((a: IAsset) => {
          return {
            ...a,
            analytics: {
              ...a.analytics,
              reactions: {
                ...a.analytics?.reactions,
                summary: a.analytics?.reactions?.summary.map((r: IAssetReactionSummary) => {
                  return {
                    order: AssetReactionOrder[r.reaction],
                    ...r
                  }
                })
              }
            }
          }
        })
      );
    }

    if (_.get(data, 'assetFeeds.length', 0) > 0) {
      (_.get($store, 'Data.assetFeeds$') as any)?.next(data.assetFeeds);
    }
  }).finally();
}
